/**
 * Optional performance reporting hook (Create React App default).
 *
 * When a callback is provided, this dynamically imports the `web-vitals` package and reports
 * common Core Web Vitals metrics (CLS/INP/FCP/LCP/TTFB).
 *
 * This dynamic import keeps the initial bundle smaller when performance reporting isn't used.
 *
 * @param {(metric: any) => void} onPerfEntry
 */
const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import("web-vitals").then(({ getCLS, getINP, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getINP(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
